export const IMAGE_TOO_BIG = 'too big'
export const IMAGE_TOO_SMALL = 'too small'
export const WRONG_FILE_TYPE = 'wrong file type'
export const WRONG_FORMAT_IMAGE_NAME = 'wrong format image name'
export const UNKNOWN_DOMAIN = 'unknown domain'
export const IMAGE_ALREADY_EXIST = 'image already exist'
export const SPECIAL_CHARACTERS_FIRST_LAST_NAME = '[`~?!@#$%^&№*,.<>;:"/[\\]|{}()=_+\\\\]'
export const SPECIAL_CHARACTERS_TEAM_NAME = '[`~?@$%^&*,<>;:"[\\]|{}=+\\\\]'
export const CONTAINS_SPECIAL_CHARACTERS = 'contains special characters'
